import { useState } from "react";
import { BookMarked, Loader2, RefreshCw } from "lucide-react";
import { CandidateCard } from "@/components/hte/CandidateCard";
import { Chip } from "@/components/hte/HteForm";
import { ARAHAN_CHIPS } from "@/lib/hte";

const MoreCandidates = ({ onSearch, busy }) => {
  const [arahan, setArahan] = useState("");
  return (
    <div className="surface rounded-2xl p-5 space-y-3 fade-up" data-testid="more-candidates-panel">
      <label htmlFor="arahan" className="eyebrow block">Arah carian (pilihan)</label>
      <input id="arahan" value={arahan} onChange={(e) => setArahan(e.target.value)} data-testid="more-candidates-input"
        placeholder="Contoh: fokus pada ayat tentang kepimpinan"
        className="w-full h-12 px-4 rounded-xl bg-bg border border-line focus:outline-none focus:border-[var(--q)]" />
      <div className="flex flex-wrap gap-2">
        {ARAHAN_CHIPS.map((c, i) => <Chip key={c} onClick={() => setArahan(c)} testid={`arahan-chip-${i}`} active={arahan === c}>{c}</Chip>)}
      </div>
      <button onClick={() => onSearch(arahan)} disabled={busy} data-testid="more-candidates-submit"
        className="h-11 px-5 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <RefreshCw size={15} />} Cari 3 calon baharu
      </button>
    </div>
  );
};

const OwnRefs = ({ onAdd, busy, failed }) => {
  const [refs, setRefs] = useState("");
  return (
    <div className="surface rounded-2xl p-5 space-y-3 fade-up" data-testid="own-refs-panel">
      <label htmlFor="own-refs" className="eyebrow block">Rujukan ayat (pisahkan dengan koma)</label>
      <input id="own-refs" value={refs} onChange={(e) => setRefs(e.target.value)} data-testid="own-refs-input"
        placeholder="2:153, Al-Anfal 46, 3:159-160"
        className="w-full h-12 px-4 rounded-xl bg-bg border border-line font-mono-data text-sm focus:outline-none focus:border-[var(--q)]" />
      <button onClick={() => refs.trim() && onAdd(refs)} disabled={busy || !refs.trim()} data-testid="own-refs-submit"
        className="h-11 px-5 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <BookMarked size={15} />} Tambah sebagai calon
      </button>
      {failed?.length > 0 && (
        <ul className="text-sm text-warn space-y-1" data-testid="own-refs-failed">
          {failed.map((f) => <li key={f.input}><span className="font-mono-data">{f.input}</span> — {f.error}</li>)}
        </ul>
      )}
    </div>
  );
};

export const CandidatePanel = ({ cards, selectedId, onPick, onMore, onOwn, busy, ownFailed, picking, hideMore }) => {
  const [panel, setPanel] = useState(null);
  const toggle = (p) => setPanel(panel === p ? null : p);
  return (
    <section className="space-y-5" data-testid="candidates-section">
      <div className="eyebrow">Calon ayat</div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {cards.map((c, i) => <CandidateCard key={c.id + c.sumber} c={c} index={i} selected={selectedId === c.id} onPick={onPick} disabled={picking} />)}
      </div>
      {!hideMore && <div className="flex flex-wrap gap-3">
        <button onClick={() => toggle("more")} data-testid="find-more-candidates-button"
          className={`h-11 px-5 rounded-full border text-sm inline-flex items-center gap-2 transition-colors ${panel === "more" ? "border-[var(--q)] text-q" : "border-line text-ink hover:bg-surface"}`}>
          <RefreshCw size={15} /> Cari calon lain
        </button>
        <button onClick={() => toggle("own")} data-testid="use-own-refs-button"
          className={`h-11 px-5 rounded-full border text-sm inline-flex items-center gap-2 transition-colors ${panel === "own" ? "border-[var(--q)] text-q" : "border-line text-ink hover:bg-surface"}`}>
          <BookMarked size={15} /> Guna ayat dari kajian saya
        </button>
      </div>}
      {panel === "more" && <MoreCandidates onSearch={onMore} busy={busy} />}
      {panel === "own" && <OwnRefs onAdd={onOwn} busy={busy} failed={ownFailed} />}
    </section>
  );
};
